<script>
    import Logo from "$/components/Logo.svelte";
    import SvgIcon from "$/components/SVGIcon.svelte";
    import { TokenStore } from "$/stores/TokenStore.js";
    import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";
    import { params, redirect } from "@roxi/routify";
    import { ServiceConsts } from "$/services/ServiceConsts";
    import { getTextColor } from "$/utils/Utils";
    import { clickAction } from "$/utils/clickAction";

    let userInitials = null;
    let loadingUI = true;

    $: TokenStore.init().then(() => {
        if (!$TokenStore.user) return;
        userInitials =
            !$TokenStore.user?.firstName && !$TokenStore.user?.lastName
                ? "CW"
                : ($TokenStore.user?.firstName
                      ? $TokenStore.user?.firstName.substring(0, 1)
                      : "") +
                  ($TokenStore.user?.lastName
                      ? $TokenStore.user?.lastName.substring(0, 1)
                      : "");
    });

    let primaryColor = "#374151";
    let textColor = "#ffffff";
    let logoUrl;

    $: {
        if ($ActiveTopic) {
            primaryColor =
                $ActiveTopic?.tenant?.theme?.primaryColor || "#374151";
            textColor = getTextColor(primaryColor);
            if ($ActiveTopic?.tenant?.theme?.logoUrl != null)
                logoUrl =
                    ServiceConsts.CDN_PUBLIC_URL +
                    $ActiveTopic.tenant.theme.logoUrl;

            loadingUI = false;
        }
    }

    function goToDashboard() {
        // if it's production, redirect to dashboard
        if (window.location.href.includes(ServiceConsts.SHARED_DOMAIN)) {
            window.location.href =
                ServiceConsts.DASHBOARD_URL + `/${$params.topicId}`;
            return;
        }

        $redirect(`/${$params.topicId}`);
    }
</script>

<div class="page">
    <div
        class="appbar"
        class:appbar--hidden={loadingUI}
        style="background-color: {primaryColor}"
    >
        {#if logoUrl && logoUrl !== ServiceConsts.CDN_PUBLIC_URL}
            <img class="logo_wrapper" src={logoUrl} alt="Collabwriting logo" />
        {:else}
            <!-- collabwriting logo -->
            <Logo />
        {/if}

        <div class="appbar-right" style="color: {textColor} !important">
            <!-- help button -->
            <a
                class="appbar-right__help"
                href={ServiceConsts.HELP_URL}
                target="_blank"
                rel="noreferrer"
            >
                <SvgIcon
                    name="question-mark-circle"
                    color={textColor}
                    size="20"
                />
            </a>

            {#if !userInitials}
                <div
                    use:clickAction={() =>
                        $redirect(
                            `/auth/login?redirectUrl=/v/${$params.topicId}`,
                        )}
                >
                    <span class="appbar-right__login"> Login </span>
                </div>
            {:else}
                <!-- user initials icon -->
                <div use:clickAction={goToDashboard}>
                    <span class="appbar-right__profile">
                        {userInitials}
                    </span>
                </div>
            {/if}
        </div>
    </div>

    <slot />

    <footer>
        <p>Made with 💛 by Collabwriting Team</p>
        <p>Copyrights &copy; {new Date().getFullYear()} Collabwriting</p>
    </footer>
</div>

<style>
    @import "../../main.css";

    img.logo_wrapper {
        @apply max-h-full;
    }

    .appbar {
        @apply flex h-10 w-full items-center justify-start px-4 py-2;
    }

    .appbar--hidden {
        @apply hidden;
    }

    .appbar-right {
        @apply ml-auto flex flex-row gap-2;
    }

    .appbar-right__help {
        @apply m-auto;
    }

    .appbar-right__login {
        @apply grid cursor-pointer select-none place-items-center rounded-full text-base;
    }

    .page {
        @apply flex h-dvh w-full min-w-full flex-col items-center justify-between;
    }

    .appbar-right__profile {
        @apply my-auto grid h-7 w-7 cursor-pointer select-none place-items-center rounded-full bg-gray-900 text-base text-white;
    }

    footer {
        @apply w-full bg-white px-8 py-3 text-center text-sm font-light text-black;
    }
</style>
